module.exports = __webpack_public_path__ + "assets/images/avatar_longevidade.cd54e97c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/avatar_longevidade.png
// module id = 680
// module chunks = 1